import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { Link } from '@calendly/ui/components/link';
import classNames from 'classnames';
import { groupBy, compact } from 'lodash-es';
import { nanoid } from 'nanoid';
import { useMemo, forwardRef } from 'react';
import InvalidFormatErrorIconSvg from 'images/icons/interface-alert-warning-circle.svg';
import AlreadyInvitedErrorIconSvg from 'images/icons/user-exclamation.svg';
const wrapperCss = "wpv6rml";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
const errorContainerCss = "e1pgr32w";
const ErrorContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(errorContainerCss, props.className)} />;
});
const errorTextCss = "e1vxjui9";
const ErrorText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(errorTextCss, props.className)} />;
});
const alreadyInvitedErrorIconCss = "a1gslo4e";
const AlreadyInvitedErrorIcon = forwardRef((props, ref) => <AlreadyInvitedErrorIconSvg ref={ref} {...props} className={classNames(alreadyInvitedErrorIconCss, props.className)} />);
const invalidFormatErrorIconCss = "i1mt0itn";
const InvalidFormatErrorIcon = forwardRef((props, ref) => <InvalidFormatErrorIconSvg ref={ref} {...props} className={classNames(invalidFormatErrorIconCss, props.className)} />);
const iconContainerCss = "i1tjnqko";
const IconContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(iconContainerCss, props.className)} />;
});
const styledErrorLinkCss = "sckmcbm";
const StyledErrorLink = forwardRef((props, ref) => <Link ref={ref} {...props} className={classNames(styledErrorLinkCss, props.className)} />);
const DomainControlLink = ({
  children
}) => <StyledErrorLink rel="noopener noreferrer" target="_blank" href="https://help.calendly.com/hc/en-us/articles/12156152891671-Domain-Control-with-Calendly">
    {children}
  </StyledErrorLink>;
const customErrorHandlingMap = {
  controlled_domain: emails => {
    const uniqueDomains = [...new Set(emails.map(email => email.split('@')[1]))];
    return {
      code: 'controlled_domain',
      message: HtmlParser(I18n.t('publisher.organization.invite_flow.add_emails_step.emails_input_field.error.email.controlled_domain', {
        value: uniqueDomains.join(', '),
        count: uniqueDomains.length
      }), {
        DomainControlLink
      })
    };
  }
};
export const useBulkOfErrorMessages = errors => {
  const errorMessages = useMemo(() => {
    const errorKeys = compact(errors.map(obj => obj && obj.email).flat());
    if (!errorKeys.length) return [];
    const grouped = groupBy(errorKeys, ({
      key
    }) => key);
    return Object.keys(grouped).map(key => {
      const emailsValues = grouped[key].map(({
        value
      }) => value);
      const customErrorHandling = customErrorHandlingMap[key];
      if (customErrorHandling) {
        return customErrorHandling(emailsValues);
      }
      return {
        code: key,
        // i18n-tasks-use t('publisher.organization.invite_flow.add_emails_step.emails_input_field.error.email.cannot_be_changed')
        // i18n-tasks-use t('publisher.organization.invite_flow.add_emails_step.emails_input_field.error.email.already_invited')
        // i18n-tasks-use t('publisher.organization.invite_flow.add_emails_step.emails_input_field.error.email.already_organization_member')
        // i18n-tasks-use t('publisher.organization.invite_flow.add_emails_step.emails_input_field.error.email.duplicate_entry')
        // i18n-tasks-use t('publisher.organization.invite_flow.add_emails_step.emails_input_field.error.email.invalid')
        message: I18n.t(`publisher.organization.invite_flow.add_emails_step.emails_input_field.error.email.${key}`, {
          value: emailsValues.join(', '),
          count: emailsValues.length
        })
      };
    });
  }, [errors]);
  return errorMessages;
};
export const InvitationErrorIcons = ({
  types = []
}) => {
  const isInvalid = types.includes('invalid') || types.includes('duplicate_entry');
  const isAlreadyInvited = types.includes('already_invited') || types.includes('already_organization_member');
  return <>
      {isInvalid && <InvalidFormatErrorIcon />}
      {isAlreadyInvited && <AlreadyInvitedErrorIcon />}
    </>;
};
export const ErrorsNotification = ({
  errors
}) => <Wrapper>
    {errors.map(({
    message,
    code
  }) => <ErrorContainer key={nanoid(8)}>
        <IconContainer>
          <InvitationErrorIcons types={[code]} />
        </IconContainer>
        <ErrorText aria-live="assertive">
          {message}
        </ErrorText>
      </ErrorContainer>)}
  </Wrapper>;

require("./errors.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./errors.js");